import React, { PropTypes } from 'react'
import { common } from '../../../lib/transform/parsers/common'

/**
 * [Component to display Quote Unquote Card]
 * This has 3 layouts
 *  - with headshot, primary text, secondary text
 *  - without headshot, primary text, secondary text
 *  - with headshot, primary text
 * @param  {[type]} options.data   [details of an quote]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Quote Unquote as a div]
 */
export const QuoteCard = ({
  data,
  style,
  index,
  states
}) => {
  let slideContent = <span></span>
  let hasHeadshot = false
  var slideclassname
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(typeof data.headline === 'undefined') {
    return <span></span>
  }
  if(typeof data.image === 'undefined') {
    hasHeadshot = false
    slideContent = (
      <div className="content">
        <p className="primary-text">{data.quote}</p>
        <span className="spacer arrow"></span>
        <p className="secondary-text">{data.attribution}</p>
      </div>
    )
  }
  if((typeof data.attribution === 'undefined') && (typeof data.image !== 'undefined') && (typeof data.quote !== 'undefined')) {
    hasHeadshot = true
    slideContent = (
      <div className="content">
        <a href={data.href} className="headshot headshot-xl athlete" tabIndex="0">
          <img data-src="http://a.espncdn.com/combiner/i?img=/i/headshots/nhl/players/full/3114.png&amp;w=168&amp;h=168&amp;scale=crop&amp;transparent=true" className="lazyload" />
        </a>
        <p className="primary-text">{data.quote}</p>
        <span className="spacer arrow"></span>
        <a href={data.href} className="read-more" tabIndex="0">Read more</a>
      </div>
    )
  }
  if((typeof data.attribution !== 'undefined') && (typeof data.image !== 'undefined') && (typeof data.quote !== 'undefined')) {
    hasHeadshot = true
    slideContent = (
      <div className="content">
          <a href={data.href} className="headshot headshot-md athlete" tabIndex="0">
          <img data-src={common.resizeCombinerLogo(data.image, { w:108, h:108, transparent:true, scale:'crop'  } )} className="lazyload" />
          </a>
          <p className="primary-text">{data.quote}</p>
          <span className="spacer arrow"></span>
          <p className="secondary-text">{data.attribution}</p>
      </div>
    )
  }
  if(hasHeadshot === false) {
    slideclassname = 'sub-module match-cards slick-slide'
  }else{
    slideclassname = 'sub-module match-cards has-headshot slick-slide'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  return(
    <article className={slideclassname} style={style} index={index}>
      <header>
        <h1>{data.headline}</h1>
        {slideContent}
      </header>
    </article>
  )
}
/**
 * [Component to display Number Crunching]
 * @param  {[type]} options.data   [details of an innings]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Number Crunching as a div]
 */
export const NumberCrunching = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards has-headshot slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  if(typeof data.number === 'undefined') {
    return <span></span>
  }
  if(typeof data.number !== 'undefined') {
    if(data.number === '') {
      return <span></span>
    }
  }
  return(
    <article className={slideclassname} style={style} index={index}>
      <header>
        <h1>{data.headline}</h1>
      </header>

      <div className="content">
        <p className="points lg">{data.number}</p>
        <span className="spacer"></span>
        <div className="v-align">
          <p className="secondary-text">{data.summary}</p>
        </div>
      </div>
    </article>
  )
}

/**
 * [Component to display The Cordon card]
 * @param  {[type]} options.data   [details of the specials]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [The Cordon fact slide as a div]
 */
export const TheCordonCard = ({
  data,
  style,
  index,
  states
}) => {
  if(typeof data.name === 'undefined') {
    return <span></span>
  }
  var slideclassname = 'sub-module match-cards the-cordon-card is-feature has-headshot slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let spacer = {}
  if(typeof data.href !== 'undefined') {
    spacer = <span className="spacer arrow"></span>
  }else{
    spacer = <span></span>
  }
  return (
    <article className={slideclassname} style={style} index={index}>
      <header>
          <h1>The Cordon</h1> 
      </header>
      <div className="content">
          <a href={data.href} className="headshot headshot-xl athlete" tabIndex="0">
            <img data-src={data.image} className="lazyload" />
          </a>
              <h2>{data.name}</h2>
              <p className="primary-text">
                {data.text}
              </p>
          {spacer}
          <a href={data.href} className="read-more" tabIndex="0">Read more</a>
      </div>
    </article>
  )
}

/**
 * [Component to display Features card]
 * This has 2 layouts
 *  - with heading and primary text
 *  - without heading and only primary text
 * @param  {[type]} options.data   [details of the features]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Features slide as a div]
 */
export const FeaturesCard = ({
  data,
  style,
  index,
  states
}) => {
  if(typeof data.headline === 'undefined') {
    if(typeof data.summary === 'undefined') {
      return <span></span>
    }
  }
  var slideclassname = 'sub-module match-cards is-feature has-media slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }

  let headlineTag
  let summaryTag
  let pageLink
  if(typeof data.url !== 'undefined') {
    pageLink = data.url
  }
  if(typeof data.headline !== 'undefined') {
    if(data.headline.length > 0) {
      headlineTag = <h2><a href={pageLink} target="_blank">{data.headline}</a></h2>
    }
  }
  if(typeof data.summary !== 'undefined') {
    if(data.summary.length > 0) {
      summaryTag = <p className="primary-text"><a href={pageLink} target="_blank">{data.summary}</a></p>
    }
  }
  if((typeof data.headline === 'undefined') && (typeof data.summary !== 'undefined')) {
    if(data.summary.length > 0) {
      summaryTag = <p className="primary-text"><a href={pageLink} target="_blank">{data.summary}</a></p>
    }
  }
  return (
    <article className={slideclassname} style={style} index={index}>
      <header>
          <h1>Feature</h1> 
      </header>
      <div className="content">
        {headlineTag}
        {summaryTag}
        <span className="spacer"></span>
      </div>
    </article>
  )
}

/**
 * [Component to display Photo card]
 * @param  {[type]} options.data   [details of the photo card]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [photo slide as a div]
 */
export const PhotoCard = ({
  data,
  style,
  index,
  states
}) =>{
  if((typeof data.headline === 'undefined') || (typeof data.image === 'undefined')) {
    return <span></span>
  }
  var slideclassname = 'sub-module match-cards photo-card has-media slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let photoLink
  if(typeof data.href !== 'undefined') {
    photoLink = data.href
  }
  let copyright
  if(typeof data.copyright !== 'undefined') {
    copyright = data.copyright ? data.copyright : ''
  }
  return (
    <article className={slideclassname} style={style} index={index}>
      <div className="content no-thumb">
        <figure className="feed-item-figure">
        <div className="img-wrap external" href="#">
        <picture>
          <a href={photoLink} target="_blank"><img data-src={data.image} className="lazyload" /></a>
        </picture>
        </div>
        </figure>
        <p className="secondary-text"><a href={photoLink} target="_blank">{data.headline} <span dangerouslySetInnerHTML={ { __html: copyright } } /></a></p>
    </div>
    </article>
  )
}
/**
 * [formatVideoTime change time format to strip extra zeros]
 * @param  {[type]} t [time duration]
 * @return {[type]}   [returns duration without zeros]
 */
export function formatVideoTime(t) {
  if(t.length > 0) {
    var duration_arr = t.split(':')
    var duration_arr_n = []
    var duration_arr_val = []
    var duration = ''
    for(let i in duration_arr) {
      duration_arr_val = parseInt(duration_arr[i],10)
      if(duration_arr_val > 0) {
        duration_arr_n.push(duration_arr_val)
      }
    }
    duration = duration_arr_n.join(':')
    return duration
  }
}
/**
 * [Component to display Video card]
 * @param  {[type]} options.data   [details of the video card]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [video slide as a div]
 */
export const VideoCard = ({
  data,
  style,
  index,
  states
}) => {
  if((typeof data.headline === 'undefined') || (typeof data.duration === 'undefined') || (typeof data.image === 'undefined')) {
    return <span></span>
  }
  var slideclassname = 'sub-module match-cards video-card has-media slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let duration
  let videoLink
  if(typeof data.duration !== 'undefined') {
    if(data.duration !== '') {
      duration = formatVideoTime(data.duration)
    }
  }
  if((typeof data.image === 'undefined') || (typeof data.duration === 'undefined')) {
    if((data.duration === '') || (data.image === '')) {
      return <span></span>
    }
  }
  if(typeof data.href !== 'undefined') {
    videoLink = data.href
  }
  return (
    <article className={slideclassname} style={style} index={index}>
      <div className="content video-wrapper">
        <figure className="feed-item-figure video">
          <div className="img-wrap">
            <picture>
              <img src={data.image} className="imageLoaded" />
            </picture>
            <span className="video-play-button">Play</span>
            <span className="video-length">{duration}</span>
          </div>
        </figure>
        <p className="secondary-text"><a href={videoLink} target="_blank">{data.headline}</a></p>
      </div>
    </article>
  )
}
/**
 * [Component to display Specials card]
 * @param  {[type]} options.data   [details of the specials]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Specials slide as a div]
 */
export const SpecialsCard = ({
  data,
  style,
  index,
  states
}) => {
  if(typeof data.text === 'undefined') {
    return <span></span>
  }
  var slideclassname = 'sub-module match-cards specials-card has-media slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  return (
    <article className={slideclassname} style={style} index={index}>
      <header>
          <h1>Specials</h1> 
      </header>
      <div className="content no-thumb">
          <figure className="feed-item-figure sm">
            <div className="img-wrap external" href="#">
              <picture>
                <img src={data.image} className="imageLoaded" />
              </picture>
            </div>
          </figure>
          <p className="secondary-text">{data.text}</p>
      </div>
    </article>
  )
}

/**
 * [Component to display Player card]
 * @param  {[type]} options.data   [details of an innings]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Player slide as a div]
 */
export const PlayerCard = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards player-card slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let playerListData = [ {} ]
  if(typeof data.list !== 'undefined') {
    playerListData = data.list
  }
  return(
    <article className={slideclassname} style={style} index={index}>
      <header>
          <h1>{data.name}</h1> 
      </header>
      <div className="content">
          <div className="player-detail">
              <div className="detail">
                  <a href={data.url} className="headshot-md athlete">
                      <img data-src={data.image} className="lazyload"/>
                  </a>
              </div>
              <div className="detail" dangerouslySetInnerHTML={{ __html : `<span>In at No ${data.position}</span> (${data.score})` }} />
              <div className="detail" dangerouslySetInnerHTML={{ __html : `<span>Last 5 innings</span> ${data.last5}` }} />
          </div>
          <table cellSpacing="0" className="player-detail-table">
              <thead>
                  <tr>
                      <th width="50"></th>
                      <th width="150" className="align-right">CAREER</th>
                      <th className="align-right">v {data.opposition}</th>
                  </tr>
              </thead>
              <tbody>
              {
                playerListData.map((player,j) => {
                  return(
                    <tr key={j}>
                        <td className="align-center">{player.name}</td>
                        <td className="align-right">{player.overall}</td>
                        <td className="align-right">{player.versus}</td>
                    </tr>
                  )
                })
              }
              </tbody>
          </table>
      </div>
  </article>
  )
}

/**
 * [Component to display Innings Slide]
 * @param  {[type]} options.data   [details of an innings]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Innings slide as a div]
 */
export const InningsCard = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards innings-card slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let inningsListData = [ {} ]
  if(typeof data.playerDetails !== 'undefined') {
    inningsListData = data.playerDetails
  }
  let inningsName
  if(typeof data.inningsID !== 'undefined') {
    let inningsID = parseInt(data.inningsID, 10)

    if(inningsID === 1) {
      inningsName = inningsID + 'st'
    }else if(inningsID === 2) {
      inningsName = inningsID + 'nd'
    }else if(inningsID === 3) {
      inningsName = inningsID + 'rd'
    }else if(inningsID === 2) {
      inningsName = inningsID + 'th'
    }
  }
  let playerLink
  return(
    <article className={slideclassname} style={style} index={index}>
        <div className="content">
            <table cellSpacing="0" className="match-table innings">
                <thead>
                    <tr style={{ backgroundColor: '#fff' }}>
                        <th width="110">{data.teamName} {inningsName} INNINGS</th>
                        <th></th>
                        <th width="25" className="align-right">R</th>
                        <th width="25" className="align-right">B</th>
                    </tr>
                </thead>
                <tbody>
                  {
                    inningsListData.map((player, i) => {
                      if(typeof player.href !== 'undefined') {
                        playerLink = player.href
                      }else{
                        playerLink = ''
                      }
                      return (
                        <tr key={i}>
                          <td><a href={playerLink} target="_blank"><span>{player.playerName}</span></a></td>
                          <td><span>{player.dismissal}</span></td>
                          <td className="align-right">{player.runs}</td>
                          <td className="align-right">{player.ballsFaced}</td>
                        </tr>
                      )
                    })
                  }
                  <tr className="total">
                      <td colSpan="1">EXTRAS</td>
                      <td colSpan="3" className="align-right">{data.extras}</td>
                  </tr>
                  <tr className="total">
                      <td colSpan="1">TOTAL</td>
                      <td colSpan="3" className="align-right">{data.runs + ' ' +data.total}</td>
                  </tr>
                </tbody>
            </table>
        </div>
    </article>
  )
}


/**
 * [Component to display Bowling Slide]
 * @param  {[type]} options.data   [details of an innings]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Innings slide as a div]
 */
export const BowlingCard = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards bowling-card slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let inningsListData = [ {} ]
  if(typeof data.playerDetails !== 'undefined') {
    inningsListData = data.playerDetails
  }
  let teamName = data.teamName || ''
  /*let inningsName
  if(typeof data.inningsNumber !== 'undefined') {
    let inningsNumber = parseInt(data.inningsNumber, 10)

    if(inningsNumber === 1) {
      inningsName = inningsNumber + 'st innings'
    }else if(inningsNumber === 2) {
      inningsName = inningsNumber + 'nd innings'
    }else if(inningsNumber === 3) {
      inningsName = inningsNumber + 'rd innings'
    }else if(inningsNumber === 4) {
      inningsName = inningsNumber + 'th innings'
    }
  }*/
  let playerLink
  return(
    <article className={slideclassname} style={style} index={index}>
        <div className="content">
            <table cellSpacing="0" className="match-table">
                <thead>
                    <tr style={{ backgroundColor: '#fff' }}>
                        <th width="110" className="align-left">{teamName} BOWLING</th>
                        <th width="20" className="align-right">O</th>
                        <th width="20" className="align-right">M</th>
                        <th width="20" className="align-right">R</th>
                        <th width="20" className="align-right">W</th>
                        <th width="35" className="align-right">Econ</th>
                        <th width="45" className="align-left"></th>
                    </tr>
                </thead>
                <tbody>
                  {
                    inningsListData.map((player, i) => {
                      if(typeof player.href !== 'undefined') {
                        playerLink = player.href
                      }else{
                        playerLink = ''
                      }

                      return (
                        <tr key={i}>
                          <td className="align-left"><a href={playerLink} target="_blank"><span>{player.playerName}</span></a></td>
                          <td className="align-right">{player.overs}</td>
                          <td className="align-right">{player.maidens}</td>
                          <td className="align-right">{player.conceded}</td>
                          <td className="align-right">{player.wickets}</td>
                          <td className="align-right">{player.economyRate}</td>
                          <td className="align-left">{player.nbw}</td>
                        </tr>
                      )
                    })
                  }
                </tbody>
            </table>
        </div>
    </article>
  )
}

/**
 * [Component to display Bowling Slide]
 * @param  {[type]} options.data   [details of an innings]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Innings slide as a div]
 */
export const PartnershipsCard = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards partnerships-card slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let inningsListData = [ {} ]
  if(typeof data.playerDetails !== 'undefined') {
    inningsListData = data.playerDetails
  }
  let teamName = data.teamName || ''
  let inningsName
  if(typeof data.inningsNumber !== 'undefined') {
    let inningsNumber = parseInt(data.inningsNumber, 10)

    if(inningsNumber === 1) {
      inningsName = inningsNumber + 'st innings'
    }else if(inningsNumber === 2) {
      inningsName = inningsNumber + 'nd innings'
    }else if(inningsNumber === 3) {
      inningsName = inningsNumber + 'rd innings'
    }else if(inningsNumber === 4) {
      inningsName = inningsNumber + 'th innings'
    }

  }
  return(
    <article className={slideclassname} style={style} index={index}>
      <header>
          <h2>{teamName} {inningsName} Partnerships</h2> 
      </header>
        <div className="content">
            <table cellSpacing="0" className="match-table" style={ { marginTop: 0 } }>
                <thead>
                    <tr style={{ backgroundColor: '#fff' }}>
                        <th width="50" className="align-center">Wkt</th>
                        <th width="20" className="align-right">Runs</th>
                        <th width="100" className="align-right">Players</th>
                        <th width="100" className="align-right"></th>
                    </tr>
                </thead>
                <tbody>
                  {
                    inningsListData.map((player, i) => {
                      return (
                        <tr key={i}>
                          <td className="align-center">{player.partnershipWicketNAme}</td>
                          <td className="align-right">{player.partnershipRuns}</td>
                          <td className="align-right">{player.player1Name}</td>
                          <td className="align-right">{player.player2Name}</td>
                        </tr>
                      )
                    })
                  }
                </tbody>
            </table>
        </div>
    </article>
  )
}
/**
 * [getPercentage get percentage from values for data]
 * @param  {[type]} val   [value to be shown]
 * @param  {[type]} total [total of both values]
 * @return {[type]}       [returns percentage/100]
 */
export function getPercentage(val, total) {
  var perc = 0
  val = parseFloat(val,10).toFixed(0)
  val = parseInt(val,10)
  perc = (val / total )
  return perc
}
/**
 * [convertToPieAngle function to change value to use for rotate property css3]
 * @param  {[type]} val [value of percentage]
 * @return {[type]}     [returns rotation angle]
 */
export function convertToPieAngle(val) {
  let rotateAngle  = 0
  rotateAngle = Math.ceil(val * 360)
  return rotateAngle
}
/**
 * [Component to display Pie chart data Slide]
 * @param  {[type]} options.data   [details of a graph]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [pie chart as as a div]
 */
export const PieChartCard = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards pie-chart slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let chartWrapStyle = {
    'width' : '170px',
    'height' : '170px'
  }
  let item1Value
  let item2Value
  let valueTotal
  let item1Name
  let item2Name
  let item1Logo
  let item2Logo
  let listData = [ {} ]

  if(typeof data.list === 'undefined') {
    return <span></span>
  }
  if(typeof data.list !== 'undefined') {
    listData = data.list
  }
  listData.map((item) => {
    if(item.type === 'boundaries') {
      item1Value = item.value
      item1Name = item.name.toUpperCase()
      item1Logo = item.image
    }else{
      item2Value = item.value
      item2Name = item.name.toUpperCase()
      item2Logo = item.image
    }
  })


  valueTotal = item1Value + item2Value

  let transformWedgeStyle1 = 'rotate(' + convertToPieAngle(getPercentage(item1Value, valueTotal)) + 'deg)'
  let transformWedgeStyle2 = 'rotate(' + convertToPieAngle(getPercentage(item2Value, valueTotal)) + 'deg)'

  item1Value = (getPercentage(item1Value, valueTotal) * 100).toFixed()
  item2Value = (getPercentage(item2Value, valueTotal) * 100).toFixed()

  let rgb1 = 'rgb(108, 213, 255)'
  let rgb2 = 'rgb(80, 171, 214)'
  let clipDefault1 = 'rect(0px 83px 170px 0px)'
  let clipDefault2 = 'auto'
  let transformWedgeContStyle1 = 'rotate(0deg)'
  let transformWedgeContStyle2 = 'rotate(' + convertToPieAngle(getPercentage(item1Value, valueTotal)) + 'deg)'
  let transformWedgeExtStyle1 = 'rotate(180deg)'

  //flip the values so the percentages/type of runs remain same with wedges
  //choose different template values to mirror graph
  if(item1Value < item2Value) {
    transformWedgeStyle1 = 'rotate(1deg)'
    transformWedgeStyle2 = 'rotate(' + (1+convertToPieAngle(getPercentage(item2Value, valueTotal))) + 'deg)'
    transformWedgeContStyle2 = 'rotate(' + (179 - convertToPieAngle(getPercentage(item2Value, valueTotal))) + 'deg)'
    transformWedgeExtStyle1 = 'rotate(' + -(180 - convertToPieAngle(getPercentage(item1Value, valueTotal))) + 'deg)'

    rgb1 = 'rgb(80, 171, 214)' 
    rgb2 = 'rgb(108, 213, 255)'
  }

  let wedgeStyle1 = {
    'transform' : transformWedgeStyle1,
    'clip' : clipDefault1,
    'backgroundColor' : rgb1
  }
  let wedgeStyle2 = {
    'transform' : transformWedgeStyle2,
    'clip' : clipDefault1,
    'backgroundColor' : rgb2
  }
  let wedgeContStyle1 = {
    'transform' : transformWedgeContStyle1,
    'clip' : clipDefault2 
  }
  let wedgeContStyle2 = {
    'transform' : transformWedgeContStyle2,
    'clip' : 'rect(0px 170px 170px 85px)'
  }
  let wedgeExtStyle1 = {
    'opacity' : '1',
    'transform' : transformWedgeExtStyle1,
    'clip' : 'rect(0px 85px 170px 0px)',
    'backgroundColor' : rgb1
  }
  let wedgeExtStyle2 = {
    'opacity' : '0'
  }

  
  return(
    <article className={slideclassname} style={style} index={index}>
        <header>
            <h1>{data.title}</h1> 
        </header>
        <div className="chart-container">
          <div className="data-chart" data-chart="4" style={chartWrapStyle}>
            <div className="outer-circle">
              <div data-wedge-id="a" className="wedge-container" style={wedgeContStyle1}>
                <div className="wedge" style={wedgeStyle1}></div>
                <div className="wedge-extension" style={wedgeExtStyle1}></div>
              </div>
              <div data-wedge-id="b" className="wedge-container" style={wedgeContStyle2}>
                <div className="wedge" style={wedgeStyle2}></div>
                <div className="wedge-extension" style={wedgeExtStyle2}></div>
              </div>
            </div>
            <div className="inner-circle">
              <span className="team-logo">
                <img src={item1Logo} className="imageLoaded" />
              </span>
              <span className="team-logo">
                <img src={item2Logo} className="imageLoaded" />
              </span>
              <span className="team-name">{item1Name}</span>
              <span className="home-team">{item2Name}</span>
              <span className="away-team">{item1Name}</span>
            </div>
          </div>
          <span className="value-home">{item1Value}</span>
          <span className="value-away">{item2Value}</span>
        </div>
    </article>
  )
}

/**
 * [Component to display Poll Slide]
 * @param  {[type]} options.data   [questions and answers]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Poll question slide as a div]
 */
export const PollCard = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards poll-results slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  let pollOptionsData = [ {} ]
  if(typeof data.options !== 'undefined') {
    pollOptionsData = data.options
  }
  return(
    <article className={slideclassname} style={style} index={index}>
        <header>
            <h1>{data.question}</h1> 
        </header>
        <div className="content mod-poll">
        <form id="poll-results" action="poll_results_submit" method="post">
            {
              pollOptionsData.map((item,i)=>{
                return(
                  <div key={i} className="wrap">
                    <input id={'radio_' + convertnumberdigitstowords(i)} type="radio" name="poll" value={i} tabIndex="0" /> 
                    <label htmlFor={'radio_' + convertnumberdigitstowords(i)}></label>
                    <div className="label">{item.option}</div>
                  </div>
                )
              })
            }
            <div className="wrap"> 
                <input type="submit" value="Vote" className="button lg" tabIndex="0" />   
            </div>
        </form>
    </div>
    </article>
  )
}
/**
 * [convertPollToPercentage converts poll percentage from number of votes]
 * @param  {[type]} votes [integer]
 * @param  {[type]} total [total votes as integer]
 * @return {[type]}       [returns total votes as percentage accurate to 2 decimals]
 */
export function convertPollToPercentage(votes,total) {
  var perc = 0
  if((typeof votes === 'number') && (typeof total === 'number')) {
    perc = ( votes / total ) * 100
    var q = perc.toString()
    var v = q.split('.')
    if(typeof v[1] !== 'undefined') {
      v = v.splice(0,1)
    }
    perc = v.join('.')
  }
  return perc
}

/**
 * [convertTotalVotes convert votes count to comma separated format]
 * @param  {[type]} totalVotes [number]
 * @return {[type]}            [votes with message as a string]
 */
export function convertTotalVotes(totalVotes) {
  var c = 0
  if(typeof totalVotes === 'number') {
    c = totalVotes
    if(c >= 1000) {
      c = c / 1000
    }
    var msg = 'vote'
    if((c === 1) && (c > 0)) {
      msg = ' vote '
    }else if(c > 1) {
      msg = ' total votes'
    }else{
      msg = ''
    }
    c = c.toString()
    c = c.split('.')
    c = c.join(',') + msg
  }
  return c
}

/**
 * [Component to display Poll Result]
 * @param  {[type]} options.data   [questions and options]
 * @param  {[type]} options.style  [default style for current class and display of slide]
 * @param  {[type]} options.index  [index of current slide in matchcards]
 * @param  {[type]} options.states [all available states]
 * @return {[type]}                [Poll result slide as a div]
 */
export const PollResult = ({
  data,
  style,
  index,
  states
}) => {
  var slideclassname = 'sub-module match-cards poll-results slick-slide'
  style = {
    'display' : 'block',
    'position' : 'absolute',
    'left' : '0',
    'top' : '0',
    'opacity' : '0',
    'zIndex' : '998'
  }
  if(states.activeslideindex === index) {
    slideclassname = slideclassname + ' slick-active slick-current'
    style = {
      'display' : 'block',
      'position' : 'absolute',
      'left' : '0',
      'top' : '0',
      'opacity' : '1',
      'transition' : 'opacity 500ms ease',
      'zIndex' : '999'
    }
  }
  var barDefaultStyle = {
    'backgroundColor' : '#f2f2f2',
    'maxWidth' : '100%'
  }
  var barPollStyle = {
    'backgroundColor' : '#5FC8F2 !important',
    'width' : '0%'
  }
  var totalVotes = convertTotalVotes(data.totalVotes)
  let pollOptionsData = [ {} ]
  if(typeof data.options !== 'undefined') {
    pollOptionsData = data.options
  }
  return(
    <article className={slideclassname} style={style} index={index}>
        <header>
            <h1>{data.question}</h1> 
        </header>
        <div className="content mod-poll">
          <ul className="compareLineGraph">
              {
                pollOptionsData.map((item,i)=>{
                  var perc = convertPollToPercentage(item.votes, data.totalVotes)
                  barPollStyle = {
                    'backgroundColor' : '#5FC8F2 !important',
                    'width' : perc +'%'
                  }
                  return(
                      <li key={'pres'+i}>
                          <span className="poll-text">{item.option}</span>
                          <span style={barDefaultStyle} className="bar-total">
                              <span style={barPollStyle} className="bar-percentage"></span>
                          </span>
                          <span className="chartValue">{perc + '%'}</span>
                      </li>
                  )
                })
              }
              <span className="chartLabel">{ totalVotes }</span>
          </ul>
    </div>
    </article>
  )
}


/**
 * [convertnumberdigitstowords helper for poll radio button ids, converts 1,2,3 etc to words]
 * @param  {[type]} n [number]
 * @return {[type]}   [word]
 */
export function convertnumberdigitstowords(n) {
  let numbArr = [ 'one','two','three','four','five','six','seven','eight' ]
  return numbArr[n] 
}

/**
 * [create functional component for prev next]
 * @param  {[type]} options.handleclickprev  [previous click event]
 * @param  {[type]} options.handleclicknext  [next click event]
 * @param  {[type]} options.activeslideindex [current slide index]
 * @param  {[type]} options.totalslides      [total no: of slides]
 * @param  {[type]} options.buttonstyle      [button default style]
 * @param  {[type]} options.ulstyle          [button wrap style]
 * @return {[type]}                          [returns navigation component]
 */
export const PrevNext = ({
  handleclickprev,
  handleclicknext,
  activeslideindex,
  totalslides,
  buttonstyle,
  ulstyle
}) => {

  var prevbuttonclassname = 'icon-font-before icon-caret-left-solid-before slick-arrow'
  var nextbuttonclassname = 'icon-font-before icon-caret-right-solid-before slick-arrow'
  if((totalslides > 0) && (totalslides === activeslideindex)) {
    nextbuttonclassname +=  ' slick-disabled'
  }
  if((totalslides > 0) && (activeslideindex === 1)) {
    prevbuttonclassname +=  ' slick-disabled'
  }
  var arrowstyle = {
    'position' : 'relative',
    'zIndex' : '1000'
  }
  return(
    <div className="match-slick-arrows" style={arrowstyle}>
      <div className="wrap">
        <div onClick={handleclickprev} className={prevbuttonclassname} style={buttonstyle}></div>
        <ul className="custom_paging" style={ulstyle} role="tablist">
          <li className="mc-active slick-active">{activeslideindex}/{totalslides}</li>
        </ul>
        <div onClick={handleclicknext} className={nextbuttonclassname} style={buttonstyle}></div>
      </div>
    </div>
  )
}


/**
 * Create Class for Match card slider
 * with previous and next buttons
 */
export class MatchCardSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeslideindex: props.activeslideindex,
      totalslides: props.totalslides
    }
  }
  static propTypes = {
    children: PropTypes.object
  }

  /**
   * [handleClickPrev Click handler to show previous slide]
   * @return {[type]} [updates current slide index]
   */
  handleClickPrev() {
    let activeslideindex = this.state.activeslideindex
    const totalslides = this.state.totalslides
    if((totalslides > 0) && (activeslideindex > 1)) {
      activeslideindex = activeslideindex - 1
      this.setState({ activeslideindex: activeslideindex })
    }
  }
  /**
   * [handleClickNext Click handler to show next slide]
   * @return {[type]} [updates current slide index]
   */
  handleClickNext() {
    let activeslideindex = this.state.activeslideindex + 1
    const totalslides = this.state.totalslides
    if((totalslides > 0) && (activeslideindex <= totalslides)) {
      this.setState({ activeslideindex: activeslideindex })
    }
  }

  /**
   * [componentDidMount Invoked after first render]
   * @return {[component]} [match cards module]
   */
  componentDidMount() {
    let { matchcards } = this.props

    if(typeof matchcards !== 'undefined') {
      matchcards = this.filterMatchCardsByTypeID(matchcards)
      let totalslides = 0
      for(let i of matchcards) {
        if(typeof i !== 'undefined') {
          totalslides = totalslides + 1
        }
      }
      this.setState({ activeslideindex: 1, totalslides: totalslides })   
    }
  }
  /**
   * [componentWillReceiveProps Updated whenever the new set of filtered slides are updated in this.props]
   * @param  {[type]} nextProps [updated match cards / filtered ones]
   * @return {[type]}           [updates slides, active, total count]
   */
  componentWillReceiveProps(nextProps) {
    let { matchcards } = nextProps
    if(typeof matchcards !== 'undefined') {
      matchcards = this.filterMatchCardsByTypeID(matchcards)
      let totalslides = 0
      for(let i of matchcards) {
        if(typeof i !== 'undefined') {
          totalslides = totalslides + 1
        }
      }
      if(totalslides > 0) {
        if(this.state.activeslideindex > totalslides) {
          this.setState({ activeslideindex: totalslides, totalslides: totalslides })
        }else{
          this.setState({ totalslides: totalslides })
        }
      }
    }
  }

/**
 * [createSlideComponent Creates the Match card slide functional component]
 * @param  {[type]} index    [index of each slide in the matchcards object]
 * @param  {[type]} key      [unique key for reactjs]
 * @param  {[type]} itemdata [data for each slide]
 * @return {[type]}          [returns sldier component]
 */
  createSlideComponent(index, key, itemdata) {
    switch(key) {
      case 1:
        return <FeaturesCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 2:
        return <PhotoCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 4:
        return <QuoteCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 6:
        return <NumberCrunching key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 11:
        return <InningsCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 12:
        return <BowlingCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 13:
        return <PartnershipsCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      /*
      case 3:
        return <VideoCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 'theCordonCard':
        return <TheCordonCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 'specialsCard':
        return <SpecialsCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 'playerCard':
        return <PlayerCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 'pieChartCard':
        return <PieChartCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 'pollCard':
        return <PollCard key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      case 'pollResult':
        return <PollResult key={'slide'+index+1} index={index+1} data={itemdata} states={this.state} />
      */
    }

  }
  /*
    //Cards and type_ids implemented
    type_id == 1 featuresCard
    type_id == 2 photoCard
    type_id == 4 quoteCard
    type_id == 6 numberCrunching
    type_id == 11 InningsCard
    type_id == 12 Bowling
    type_id == 13 Partnerships
  */
 /**
  * [filterMatchCardsByTypeID Filters match cards that are implemented]
  * @param  {[type]} matchcards [array of unfiltered cards]
  * @return {[type]}            [returns array of cards]
  */
  filterMatchCardsByTypeID(matchcards) {
    let allowed_typeids = [ 1,2,4,6,11,12,13 ]
    let cards = []
    for(let i in matchcards) {
      if(matchcards[i].hasOwnProperty('typeID') === true) {
        if(typeof matchcards[i].typeID !== 'undefined') {
          let typeID = parseInt(matchcards[i].typeID, 10)
          let card = allowed_typeids.indexOf(typeID)
          if((typeof card !== 'undefined') && (card >= 0)) {
            cards.push(matchcards[i])
          }
        }
      }
    }
    return cards
  }
  
  render() {
    let PrevNextButtons
    let slides
    var prevNextStyle = { 
      'display': 'inline-block'  
    }
    var ulStyle = { 
      'display': 'inline-block'  
    }
    
    //return nothing if matchcards is not found
    if(typeof this.props.matchcards === 'undefined') {
      return <div></div>
    }
    
    let { matchcards } = this.props
    matchcards = this.filterMatchCardsByTypeID(matchcards)
    if(typeof matchcards !== 'undefined') {
      let itemdata = {}
      slides = Object.keys(matchcards).map((index, key) => {
        index = parseInt(index, 10)
        if(typeof matchcards[key] !== 'undefined') {
          key = parseInt(matchcards[key].typeID, 10)
          itemdata = matchcards[index]
          return this.createSlideComponent(index, key, itemdata)
        }
      })
      if(this.state.totalslides > 0) {
        PrevNextButtons = <PrevNext key="pn" buttonstyle={prevNextStyle} ulstyle={ulStyle} totalslides={this.state.totalslides} activeslideindex={this.state.activeslideindex} handleclicknext={this.handleClickNext.bind(this)} handleclickprev={this.handleClickPrev.bind(this)} />
      }
    }


    const content = (
      <div className="match-cards-slider slick-initialized slick-slider">
        <div className="sub-module match-cards">
          {slides}
        </div>
        {PrevNextButtons}
      </div>
    )

    return slides.length ? content : <div className="match-cards-slider slick-initialized slick-slider"/>
  }
}

// Set default state for current slide and total slide
MatchCardSlider.defaultProps = {
  totalslides: 0,
  activeslideindex: 0
}

export default MatchCardSlider





// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/MatchCards.jsx